import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import styles from 'styles/css/Main.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import actionStyles from 'styles/css/ActionStyles.module.scss';
import Logo from 'styles/images/logo/logo512.png';
import Instagram from 'styles/images/svg/instagram.svg';
import LinkedIn from 'styles/images/svg/linkedin.svg';
import YouTube from 'styles/images/svg/youtube.svg';
import Facebook from 'styles/images/svg/facebook.svg';
import ForwardIcon from 'styles/images/svg/forward-white.svg';
import ArrowUp from 'styles/images/svg/arrow-up.svg';
import ArrowDown from 'styles/images/svg/arrow-down.svg';
import { API_PRODUCT_DETAILS, USERS_LOGOUT_GET } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataPageProductDetails } from 'reduxx/actions/pages/products/details';
import BackIcon from 'styles/images/svg/back.svg';
import shortHeaderStyles from 'styles/css/ShortHeaderStyles.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import { useLocalePath } from 'utils/useLocalePath';

const ProductDetails = () => {

    const { i18n } = useTranslation();
    const { t } = useTranslation();
    const to = useLocalePath();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { catId, catTitle } = useParams();

    const { cats } = useSelector(state => state.categories);
    const { content } = useSelector(state => state.productDetails);



    useEffect(() => {
        apiProductDetails();
    }, [ProductDetails, catId]);

    const apiProductDetails = () => {
        apiRequest({
            dispatch,
            endpoint: API_PRODUCT_DETAILS,
            method: 'post',
            data: {width: window.innerWidth, category: catId},
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataPageProductDetails('content', res.content));
            }
        });
    };


    return (
        
        <div className={[sharedStyles.container, sharedStyles['pb-[64px]']].join(' ')} >


            <section className={styles.hero} >
                <div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.itemsCenter, sharedStyles['py-s'], sharedStyles['px-s'], sharedStyles.absolute, sharedStyles['top-0'], sharedStyles['z-2'], sharedStyles['bg-white-[0.2]']].join(' ')}>
                    <img onClick={() => navigate(-1)} className={shortHeaderStyles['back-btn']} src={BackIcon} width={18} height={18}  />
                </div>
                <Swiper
                    dir={i18n.dir()}
                    modules={[Pagination, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={1}
                    // pagination={{ clickable: true }}
                    // navigation={true}
                    pagination={false}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    className={styles.swiper}
                >
                    {content.images && content.images.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div className={styles.slide} style={{ backgroundImage: `url(${slide})` }}></div>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </section>



            <div className={sharedStyles['container-padding']}>
            <div className={sharedStyles['container-padding']}>
            <div className={sharedStyles['container-padding']}>
                <h1>{content.title && content.title}</h1>
                <p className={ruleStyles['text-justify']}>
                    {content.description && content.description}
                </p>
                <Link to={to(`/consultation`)} className={[styles['cta-full'], styles['mt-24']].join(' ')} style={{position: "fixed", bottom: "16px", textDecoration: "none", width: "unset", right: "16px", left: '16px', textAlign: "center"}}>{t("consult_req")}</Link>
            </div>
            </div>
            </div>

            
        </div>

    );
}

export default ProductDetails;